<template>
  <div class="video-box">
    <my-video ref="myVideo" :gameId="gameId" @play="bindplay" @payVideo="payVideo" :videoPaidCategory="videoPaidCategory" @openPkay="popShow = true" :price="price" :pvCount="pvCount" :isVideoPaid="isVideoPaid" :isBoughtLive="isBoughtLive"></my-video>
    <!-- <button @click="goWxPages">跳转到微信小程序</button> -->
    <div class="head" ref="head">
      <div class="head-box" :style="{height:videoUrl ? '211px': '176px'}" v-if="false">
        <div v-if="videoUrl" class="video">
          <video controls :style="{width:'100%',height:'100%'}" :src="videoUrl"></video>
        </div>
        <div v-else class="vs-score">
          <vs-head :obj="game" :match="match"></vs-head>
        </div>
      </div>
      <div class="content" v-if="game.homeTeam">
        <div class="game-name flex-conter" @click="goPages">
          <div class="name flex-conter">
            <img style="min-width: 16px;margin-right: 6px;" :src="match.icon" />
            <p class="overflow-text">{{ match.matchName }}</p>
          </div>
          <img style="min-width: 16px;" src="http://images.snsports.cn/bsn_right.png" />
        </div>
        <div class="encounter flex-conter" v-if="game.homeTeam.liked === 0 && game.awayTeam.liked === 0">
          <div class="left flex-conter" @click="likeGameTeam('home',game.homeTeam.id)">
            <img src="http://images.snsports.cn/bsn_ praise.png" style="min-width: 19.5px;height: 17.5px;margin-right: 7px;width:19.5px;" />
            <p class="overflow-text" style="padding-right: 5px;">{{ game.homeTeam && game.homeTeam.name }}</p>
          </div>
          <img src="http://images.snsports.cn/bsn_vs.png" style="width: 34px;height: 36px;" />
          <div class="right flex-conter" @click="likeGameTeam('away',game.awayTeam.id)">
            <p class="overflow-text" style="padding-left: 5px;">{{ game.awayTeam&& game.awayTeam.name }}</p>
            <img src="http://images.snsports.cn/bsn_ praise.png" style="min-width: 19.5px;height: 17.5px;margin-left: 7px;width: 19.5px;" />
          </div>
        </div>
        <div v-else class="bifen">
          <div class="flex-conter zan">
            <div class="flex-conter">
              <img :src="`http://images.snsports.cn/bsn_left_${game.homeTeam.liked === 0 ? 1 : 2}.png`" style="margin-right: 6px;margin-top: -2px;" />
              {{ game.homeTeam.liked === 0 ? '': '已支持'}} {{percentage}}%
              <!-- game.homeTeam.liked === 0 && game.awayTeam.liked === 0 -->
            </div>
            <div class="flex-conter">
              {{ game.awayTeam.liked === 0 ? '': '已支持'}} {{100 - percentage}}%
              <img :src="`http://images.snsports.cn/bsn_right_${game.awayTeam.liked === 0 ? 1 : 2}.png`" style="margin-left: 6px;margin-top: -2px;" />
            </div>
          </div>
          <div class="picture flex-conter">
            <div class="left" :style="{width:percentage + '%'}"></div>
            <img src="http://images.snsports.cn/bsn_ lightning.png" class="img" :style="{width: '18px',height: '18px',left:percentage + '%'}" />
            <div class="right" :style="{width:(100 - percentage) + '%'}"></div>
          </div>
          <div class="flex-conter team-box">
            <div class="flex-conter">
              <img :src="game.homeTeam.badge" style="margin-right: 8px;" />
              {{ game.homeTeam.name }}
            </div>
            <div class="flex-conter">
              {{ game.awayTeam.name }}
              <img :src="game.awayTeam.badge" style="margin-left: 8px;" />
            </div>
          </div>
        </div>
      </div>
      <div class="tabs-box">
        <div>
          <!-- <u-tabs :list="tabsList" :is-scroll="false" inactive-color="#9A9A9A" active-color="#000" :bar-style="{background:'#E72828'}" :current="current" @change="change"></u-tabs> -->
          <van-tabs :active="current" line-width="20px" @change="change">
            <van-tab title="集锦" :name="0"></van-tab>
            <van-tab title="数据" :name="1"></van-tab>
            <van-tab title="事件" :name="3" v-if="beibingGameId"></van-tab>
            <van-tab title="互动" :name="2"></van-tab>
          </van-tabs>
        </div>
      </div>
    </div>
    <!-- tabs -->
    <div>
      <ji-jin :infoImg="infoImg" :cols="cols" :whole="whole" :lives="lives" @videoUrl="updataVideoUrl" v-show="current === 0"></ji-jin>
      <game-data :sportType="sportType" :gameId="gameId" :beibingGameId="beibingGameId" v-if="current === 1"></game-data>
      <event-list v-if="current === 3" :beibingGameId="beibingGameId"></event-list>
      <mutual @isLogin="isLogin" :passport="passport" :infoImg="infoImg" :height="height" :gameId="gameId" :game="game" v-else-if="current === 2"></mutual>
    </div>
    <van-popup v-model="popShow" position="bottom" border-radius="44">
      <div class="popUp">
        <div class="pop_top">
          <div class="pop_top_1">
            <div class="pop_top_text">
              <p class="p1">立即开通赛事VIP，解锁全部精彩内容</p>
            </div>
            <div class="pop_top_close" @click="popShow = false">
              <van-icon name="cross" color="#FFF" size="15" />
            </div>
          </div>
          <div class="sku-box">
          <div class="sku">
            <div class="sku-item" :class="{ 'sku-item-active': type == 'match' }" @click="switchType('match')">
              <div class="label">赛事包</div>
              <div class="text">全部比赛随心看</div>
              <div class="price"><span>¥</span>{{ vipPrice[0] }}</div>
            </div>
            <div class="sku-item" :class="{ 'sku-item-active': type == 'team' }" @click="switchType('team')">
              <div class="label">专属球队包</div>
              <div class="text">为主队摇旗呐喊</div>
              <div class="price" v-if="videoPaidModel.includes('2')"><span>¥</span>{{ teamVideoPrice }}</div>
            </div>
            <div class="sku-item" :class="{ 'sku-item-active': type == 'game' }" @click="switchType('game')">
              <div class="label">本场包</div>
              <div class="text">本场比赛随心看</div>
              <div class="price" v-if="videoPaidModel.includes('1')"><span>¥</span>{{ vipPrice[1] }}</div>
            </div>
          </div>
          </div>
          <div class="team-box" v-if="type == 'team'">
            <div class="team-item overflow-text" :class="{ 'team-item-active': teamId == game.homeTeam.id }" @click="teamId = game.homeTeam.id">{{ game.homeTeam.name }}</div>
            <div class="team-item overflow-text" :class="{ 'team-item-active': teamId == game.awayTeam.id }" @click="teamId = game.awayTeam.id">{{ game.awayTeam.name }}</div>
          </div>
          <div class="pop_top_1">
            <div class="pop_top_text">
              <p class="p2">{{ getText.title }}</p>
              <p class="p3"><van-icon name="success" color="#3FD57B" size="14" style="margin-right: 12rpx;" /> {{ getText.text }}</p>
              <p class="p3"><van-icon name="success" color="#3FD57B" size="14" style="margin-right: 12rpx;" /> {{ getText.text2 }}</p>
              <p class="p3"><van-icon name="success" color="#3FD57B" size="14" style="margin-right: 12rpx;" /> 比赛精彩片段 不限下载次数</p> 
            </div>
          </div>
        </div>
        <div class="pop_bottom">
          <div class="pop_bottom_box1">
            <img src="https://images.snsports.cn/vipInformIcon.png" v-if="!ifVipInform" @click="ifVipInform = true" />
            <img src="https://images.snsports.cn/vipInformIconOk.png" v-if="ifVipInform" @click="ifVipInform = false" />
            <span class="s1" @click="ifVipInform = !ifVipInform">开通前请仔细阅读</span>
            <span class="s2" @click="goAgreement()">《北京冰球协会会员服务协议》</span>
          </div>
          <div class="pop_bottom_box2 flex-conter pop_bottom_box2_active">
            <div class="left flex-conter left_active">
              <div>{{ type == 'match' ? '赛事会员' : '专属球队包' }}</div>
              <p v-if="haveCouponTicket === 1 && type == 'match'"><span>¥</span>0.0</p>
              <p v-else-if="type === 'match'"><span>¥</span>{{ vipPrice[0] }}</p>
              <p v-else-if="type === 'team'"><span>¥</span>{{ teamVideoPrice }}</p>
              <p v-else-if="type === 'game'"><span>¥</span>{{ vipPrice[1] }}</p>
            </div>
            <div class="rigth right_active" @click="openPayment(type)">立即开通</div>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import wx from 'weixin-js-sdk'
import Vue from 'vue';
import { Tabs, Tab,Popup,Checkbox,Toast,Icon } from 'vant';
Vue.use(Tabs).use(Tab).use(Popup).use(Checkbox).use(Toast).use(Icon)
import GameData from './components/GameData.vue'
import JiJin from './components/JiJin.vue'
import Mutual from './components/Mutual.vue'
import VsHead from './components/VsHead.vue'
import { QNImageUtil, DateUtil } from '@/utils'
import { GetBMGameLiveDetail,BKLikeGameTeam,OnPlayGameVideo,GetMatchLivePriceSetting,BYCreateOrder  } from '@/api/match'
import MyVideo from './components/MyVideo.vue'
import { getProfile } from '@/api/user'
import {getPassport} from "@/libs/passport";
import EventList from './components/eventList.vue'
export default {
components: { VsHead,JiJin,GameData,Mutual, MyVideo, EventList },
data() {
  return {
    tabsList: [{ name: '集锦' }, { name: '数据' }, { name: '互动' }],
    current: 0,
    game: {},
    match: {},
    whole: {},
    cols: [],
    lives: [],
    videoUrl: '',
    gameId: null,
    vipIndex: 1,
    teams: [],
    stages: [],
    sportType: '',
    height: null,
    width: null,
    percentage: 50,
    infoImg: '',
    passport:'',
    popShow:false,
    vipPrice: [0, 0, 0],
    ifVipInform:false,
    isVideoPaid:false, // 是否需要付费
    isBoughtLive: false, // 是否已经购买
    pvCount:'',
    price:'',
    videoPaidFlag: [false, false],
    userId: '',
    haveCouponTicket: 0,
    videoPaidCategory: 0,
    beibingGameId: '',
    videoPaidModel: '',
    type: 'match',
    teamVideoPrice: 0,
    teamId: ''
  }
},
created() {
  if (!this.$route.query.passport) {
    wx.miniProgram.navigateTo({
        url: `/pages/common/login`
      })
  }
  this.gameId = Number(this.$route.query.gameId)
  this.passport = this.$route.query.passport
  this.sportType = this.$route.query.sportType
},
computed: {
  getText() {
    if (this.type === 'match') { 
      return {
        title: '赛事VIP特权',
        text: '所有比赛回看 不限观看时长',
        text2: '畅看全部精彩片段和视频集锦'
      }
    } else if (this.type === 'team') {
      return {
        title: '专属球队包VIP特权',
        text: '专属球队比赛回看 不限观看时长',
        text2: '畅看专属球队全部精彩片段和视频集锦'
      }
    } else if (this.type === 'game') {
      return {
        title: '本场包VIP特权',
        text: '本场比赛回看 不限观看时长',
        text2: '畅看本场比赛精彩片段和视频集锦'
      }
    }
    return {}
  }
},
mounted() {
  // this.sportType = '足球'
  this.GetBMGameLiveDetail()
  setTimeout(() =>{
    const videoH = this.$refs.myVideo.$el.offsetHeight
    const headH = this.$refs.head.offsetHeight
    this.height = videoH + headH
    this.current = 2
  },300)
  getPassport(true).then(res => {
    if (res) {
      this.getProfile()
    }
  })
},
methods: {
  switchType(type) {
    if (type === 'match' && !this.videoPaidModel.includes('0')) {
      this.$toast('赛事包暂未开放')
      return
    }
    if (type === 'team' && !this.videoPaidModel.includes('2')) {
      this.$toast('专属球队包暂未开放')
      return
    }
    if (type === 'game' && !this.videoPaidModel.includes('1')) {
      this.$toast('本场包暂未开放')
      return
    }
    this.type = type
  },
  change(e) {
    this.current = e
  },
  isLogin(){
    if(this.passport) return false
    wx.miniProgram.navigateTo({
      url: `/pages/common/login`
    })
    return false
  },
  goAgreement(){
    wx.miniProgram.navigateTo({
      url: `/pages/game/userAgreement`
    })
  },
  getProfile(){
    getProfile().then(res => {
      const { data } = res
      const user = data.user
      this.infoImg = QNImageUtil.originView(user.profile)
      this.userId = parseInt(user.id.match(/\d+/)[0])
    })
  },
  updataVideoUrl(e) {
    this.videoUrl = e
  },
  payVideo(){
    if(!this.popShow){
      if(this.isLogin()) return
    }
    this.popShow = true
  },
  GetMatchLivePriceSetting(matchId){
    const params = {
      matchId: matchId
    }
    GetMatchLivePriceSetting(params).then(res => {
      const { data } = res
      const videoPaidModel = data.videoPaidModel
      this.videoPaidModel = videoPaidModel
      if (videoPaidModel.includes('0')) {
        this.videoPaidFlag[0] = true
        this.vipPrice[0] = this.priceFormat(data.matchVideoPrice)
      }
      if (videoPaidModel.includes('1')) {
        this.videoPaidFlag[1] = true
        this.vipPrice[1] = this.priceFormat(data.gameVideoPrice)
      }
      if (this.videoPaidFlag[1] && !this.videoPaidFlag[0]) {
        this.vipIndex = 2
      }
      this.videoPaidCategory = data.videoPaidCategory
      this.price = this.priceFormat(data.gameVideoPrice)
      this.teamVideoPrice = this.priceFormat(data.teamVideoPrice)
      this.vipPrice[2] = data.matchVideoMarketPrice && this.priceFormat(data.matchVideoMarketPrice) || 0
      this.isVideoPaid = data.isVideoPaid === 1
      this.haveCouponTicket = res.data.haveCouponTicket
    })
  },
  priceFormat(p) {
    let price = (parseInt(p) * 0.01).toFixed(2)
    if (price.substr(-1, 1) === '0') {
      price = price.substr(0, price.length - 1)
    }
    return price
  },
  GetBMGameLiveDetail() {
    const params = {
      gameId: this.gameId,
      fromBmYouth: true
    }
    GetBMGameLiveDetail(params).then(res => {
      const { data } = res
      this.videoUrl = data.whole && data.whole.url
      this.game = data.game
      this.percentage = this.calculate()
      data.game.awayTeam.badge = QNImageUtil.originView(data.game.awayTeam.badge)
      data.game.homeTeam.badge = QNImageUtil.originView(data.game.homeTeam.badge)
      data.match.icon = QNImageUtil.originView(data.match.icon)
      this.match = data.match
      this.whole = data.whole
      this.cols = data.cols
      this.isBoughtLive = data.game.isBoughtLive === 1
      this.pvCount = data.game.pvCount
      if (data.game.bjhId) {
        this.beibingGameId = data.game.bjhId
      }
      this.lives = data.lives && data.lives.map(item => {
        item.poster = QNImageUtil.originView(item.poster)
        item.createDate = DateUtil.parseDateTime(item.createDate, '{m}-{d}')
        return item
      })
      this.GetMatchLivePriceSetting(data.match.id)
    })
  },
  likeGameTeam(name, teamId) {
    if(this.isLogin()) return
    const params = {
      gameId: this.gameId,
      like: 1,
      teamId
    }
    BKLikeGameTeam(params).then(() => {
      if (name === 'home') {
        this.game.homeTeam.liked = 1
        this.game.homeTeam.likeCount = this.game.homeTeam.likeCount + 1
      } else {
        this.game.awayTeam.liked = 1
        this.game.awayTeam.likeCount = this.game.awayTeam.likeCount + 1
      }
      this.percentage = this.calculate()
    })
  },
  calculate() {
    let percentage = this.game.awayTeam.likeCount + this.game.homeTeam.likeCount
    if (percentage === 0) {
      percentage = 50
    } else {
      percentage = Number((this.game.homeTeam.likeCount / percentage * 100).toFixed(0))
    }
    return percentage
  },
  bindplay(){
    const params = {
      objId: this.gameId,
      objType: 'game',
    }
    OnPlayGameVideo(params).then(res => {
      console.log(res)
    })
  },
  openPayment(type){
    if(!this.ifVipInform) {
      Toast({
        message: '请先勾选 \n《斑马邦会员服务协议》',
      })
      return
    }
     let params = {}
    if (type === 'game') {
      params = {
        category: 1,
        objId: this.game.id
      }
    } else if (type === 'match') { 
      params = {
        category: 0,
        objId: this.match.id
      }
    } else if (type === 'team') {
      if (!this.teamId) {
        this.$toast('请先选择专属球队')
        return
      }
      params = {
        category: 2,
        objId: this.match.id+'&'+this.teamId
      }
    }
    params.needNew = 1
    BYCreateOrder(params).then(res => {
      const { data } = res
      if (this.haveCouponTicket === 1 && this.vipIndex === 1) {
        this.popShow = false
        this.isBoughtLive = true
        this.isVideoPaid = !this.isVideoPaid
        Toast({
          message: '购买成功！',
        })
        return
      }
      wx.miniProgram.navigateTo({
        url: `/pages/game/h5pay?orderId=${data.orderId}`
      })
    })
  },
  goPages() {
    wx.miniProgram.navigateTo({ url: `/pages/game/index?matchId=${this.match.id}` })
  }
}
}
</script>

<style scoped lang="scss">
p{
  margin: 0;
}
.video-box{
background: #F7F7FB;
.head-box{
  height: 262.5px;
  background: linear-gradient(233deg, #131313 0%, #191919 56%, #242424 100%);
  transform: translateY(-10px);
  .vs-score{
    padding:16px;
  }
  .video{
    height: 100%;
    padding-bottom: 10px;
    video{
      width: 100%;
      height: 100%;
    }
  }
}
.content{
  // border-radius: 12px 12px 0px 0px;
  background-color: #fff;
  // transform: translateY(-10px);
  .game-name{
    padding:12px 16px;
    border-bottom: 1px solid #eee;
    img{
      width: 15px;
      height: 15px;
    }
  }
  .encounter{
    color: #FFFFFF;
    font-size: 12px;
    padding: 16px 20px;
    div{
      width: 140px;
      height: 40px;
    }
    .left{
      background: url('http://images.snsports.cn/bsn_left_bg.png') no-repeat;
      background-size: 140px 40px;
      padding-left: 16px;
      justify-content: start;
    }
    .right{
      background: url('http://images.snsports.cn/bsn_right_bg.png') no-repeat 10px 0px;
      background-size: 140px 40px;
      text-align: right;
      padding-right: 16px;
      justify-content: flex-end;
    }
  }
  .bifen{
    padding: 16px;
    font-size: 11.5px;
    .zan{
      img{
        width: 11.75px;
        height: 11.75px;
      }
    }
    .picture{
      position: relative;
      margin: 9px 0;
      .left{
        width: 230px;
        height: 8px;
        background: #26A1FF;
        border-radius: 15px 0 0 15px;
        // animation: ;
        transition: all .5s;
      }
      .img{
        position: absolute;
        left: 50%;
        transform: translateX(-9px);
        transition: all .5s;
      }
      .right{
        width: 222.5px;
        height: 8px;
        background-color: #FA6C31;
        border-radius: 0 15px 15px 0;
      }
    }
    .team-box{
      font-size: 11.5px;
      font-weight: 400;
      color: #191919;
      img{
        width: 21px;
        height: 21px;
        border-radius: 50%;
      }
    }
  }
}
.tabs-box{}
}
.flex-conter{
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.overflow-text{
  overflow : hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  word-break: break-all;
}
.popUp {
  background-color: #FFF;
  padding-top: 23px;

  .pop_top {
    .pop_top_1 {
      margin: 0 19px 6px 19px;
      display: flex;
      position: relative;

      .pop_top_text {
        padding-right: 26px;

        .p1 {
          color: #000;
          font-size: 16px;
          font-family: PingFangSC-Medium;
          font-weight: 800;
        }

        .p2 {
          font-size: 14px;
          font-weight: 500;
          color: #000;
          font-family: PingFangSC-Regular;
          // margin-left: 7px;
          margin-top: 15px;
          margin-bottom: 7px;
        }

        .p3 {
          font-size: 12px;
          margin-bottom: 8px;
          // padding-left: 31px;
          color: #8E9196;
        }
      }

      .pop_top_close {
        position: absolute;
        width: 24px;
        height: 24px;
        border-radius: 12px;
        background: #000;
        right: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }

    .pop_top_2 {
      margin-bottom: 16px;

      .icon_box {
        display: flex;
        margin-left: 20px;
        margin-bottom: 12px;

        .icon_box_img {
          width: 20px;
          height: 20px;
        }

        span {
          color: #DD9838;
          font-size: 12px;
          line-height: 12px;
          margin: 4px 0 4px 12px;
        }
      }
    }
    .sku-box {
        padding: 0 18px;
        margin-top: 24px;
        .sku {
          margin-top: 12px;
          display: flex;
          justify-content: space-between;
          .sku-item {
            width: 108px;
            height: 127px;
            border-radius: 6px;
            background: linear-gradient(228deg, #A8A8A8 0%, #DBDBDB 103%);
            box-sizing: border-box;
            padding: 15px 0 16px 8px;
            .label{
              font-size: 16px;
              font-weight: 600;
              color: #44351C;
              line-height: 1rem;
            }
            .text{
              font-size: 12px;
              color: #8F7449;
              line-height: 1rem;
              margin-top: 6px;
            }
            .price{
              display: flex;
              align-items: center;
              font-size: 28px;
              font-weight: 600;
              color: #4F3F26;
              margin-top: 33px;
              line-height: 1rem;
              span{
                font-size: 16px;
                font-weight: 500;
                margin-right: 4px;
              }
            }
          }
          .sku-item-active{
            border: 2px solid #D1AB68;
            background: linear-gradient(228deg, #FFCA7B -1%, #F9BD64 -1%, #FFF1D1 101%);
          }
        }
        .team{
          display: flex;
          align-items: center;
          justify-content: space-between;
          border: 1px solid #FBCD85;
          // width: 282px;
          height: 36px;
          border-radius: 4px;
          padding: 0 10px;
          margin: 10px 0;
          .label{
            color: #FBCD85;
            font-size: 14px;
          }
          .info{
            display: flex;
            align-items: center;
            color: #FFF;
            padding: 0;
            img{
              width: 20px;
              height: 20px;
              border-radius: 50%;
              margin-right: 9px;
            }
            span{
              font-size: 14px;
              margin-right: 3px;
              color: #FFF;
            }
          }
        }
    }
    .team-box{
      margin-top: 16px;
      padding: 0 24px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .team-item{
        padding: 0 6px;
        width: 155px;
        height: 46px;
        border-radius: 6px;
        font-size: 14px;
        color: #909399;
        border: 1px solid #D4D7DE;
        text-align: center;
        line-height: 46px;
        box-sizing: border-box;
      }
      .team-item-active{
        color: #303133;
        background: #FFF6DF;
        border: 1px solid #D1AB68;
      }
    }
  }

  .pop_middle {
    background-color: #FFFFFF;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    padding: 21px 20px 65px 20px;
    min-height: 250px;

    .p0 {
      color: #8C8C8C;
      font-size: 12px;
    }

    .pop_middle_box {
      margin-top: 12px;
      display: flex;
      padding: 12px 12px 12px 12px;
      border-radius: 6px;
      border: 1px solid #E8E8E8;
    }

    .pop_middle_box_active {
      border: 1px solid #FD5409;
      background: #FEF6F2;
    }

    .pop_middle_box1 {
      justify-content: flex-start;
      margin-top: 2px;

      .pop_middle_box1_top {
        display: flex;

        .p1 {
          color: #191919;
          font-size: 14px;
        }

        .hot {
          margin-left: 8px;
          margin-top: 2.5px;
          background-color: #FD5409;
          color: #FFFFFF;
          font-size: 10px;
          font-weight: lighter;
          text-align: center;
          width: 42px;
          height: 15px;
          border-bottom-left-radius: 15px;
          border-top-right-radius: 15px;
        }
      }

      .p2 {
        margin-top: 2px;
        color: #8C8C8C;
        font-size: 10px;
      }
    }

    .pop_middle_box2 {
      flex: 1;
      justify-content: flex-end;
      display: flex;

      .pop_middle_box2_text {
        text-align: right;

        .s1 {
          margin-right: 4px;
          color: #8C8C8C;
          font-size: 12px;
        }

        .s2 {
          color: #191919;
          font-size: 24px;
          line-height: 24px;
        }

        .p1 {
          color: #8C8C8C;
          font-size: 10px;
          line-height: 14px;
          text-decoration: line-through;
        }
      }

      .pop_middle_box2_text_active {
        .s1 {
          color: #FD5409;
        }

        .s2 {
          color: #FD5409;
        }
      }
    }
  }

  .tab {
    color: #2E5594;
    text-align: center;
    padding: 7px 0 12px 0;
    background-color: #fff;
    font-size: 12px;
  }
  .pop_top_price{
    text-align: center;
    font-size: 14px;
    color: #D54F3F;
    margin-top: 13px;
    margin-bottom: 2px;
  }

  .pop_bottom {
    background-color: #FFFFFF;
    min-height: 120px;
    padding-left: 16px;
    padding-right: 16px;

    .pop_bottom_box1 {
      display: flex;
      align-items: center;
      padding-top: 12px;

      img {
        width: 14px;
        height: 14px;
        margin-right: 8px;
      }

      .s1 {
        color: #333333;
        font-size: 14px;
      }

      .s2 {
        color: #FA6405;
        font-size: 14px;
      }
    }

    .pop_bottom_box2 {
      width: 349px;
      height: 50px;
      margin-top: 10px;
      background: linear-gradient(105deg, #3C3E45, #2F3034 60%, #EAEEF3 60%, #D1D0DC 100%);
      border-bottom-left-radius: 50px;
      border-top-left-radius: 50px;
      border-bottom-right-radius: 50px;
      border-top-right-radius: 50px;
      display: flex;

      .left {
        width: 180px;
        padding: 0 38px 0 20px;
        font-size: 12px;
        color: #B4B4B4;

        p {
          font-size: 24px;
          font-weight: 500;
          background: linear-gradient(to left, #FFD890, #FFF6DF);
          -webkit-background-clip: text;
          color: transparent;

          span {
            color: #191919;
            font-size: 16px;
            margin-right: 6px;
            background: linear-gradient(to left, #FFD890, #FFF6DF);
            -webkit-background-clip: text;
            color: transparent;
          }
        }
      }

      .left_active {
        p {
          background: linear-gradient(to left, #D1D0DC, #EAEEF3);
          -webkit-background-clip: text;
          color: transparent;

          span {
            background: linear-gradient(to left, #D1D0DC, #EAEEF3);
            -webkit-background-clip: text;
            color: transparent;
          }
        }
      }

      .rigth {
        flex: 1;
        text-align: center;
        line-height: 50px;
        font-size: 18px;
        font-weight: 600;
        color: #784808;
      }

      .right_active {
        color: #3C3B39
      }
    }

    .pop_bottom_box2_active {
      background: linear-gradient(105deg, #3C3E45, #2F3034 60%, #FFF6DF 60%, #FFD890 100%);
    }

  }
}
</style>
